import { WithTranslation, withTranslation } from 'react-i18next';
import React, { SelectHTMLAttributes, useEffect, useState } from 'react';
import { ReactComponent as NotificationLogo } from '../../styles/img/icons/error.svg';

export interface IDropdownFieldProps
    extends SelectHTMLAttributes<HTMLSelectElement>,
        WithTranslation {
    fieldContainerClassName?: string;
    fieldName: string;
    fieldTitle: string;
    fieldOptionalText?: string;
    fieldTooltip?: JSX.Element;
    fieldOptions?: JSX.Element[];
    fieldDefaultValue?: string;
    fieldId?: string;
    fieldDisabled?: boolean;
    fieldDisabledPopover?: boolean;
    value?: string | number;
    handleOnChange?: any;
    fieldRequired?: boolean;
    fieldInputClass?: string;
    fieldHiddenLabel?: string;
    fieldWeight: number;
}

const DropDownField = (props: IDropdownFieldProps) => {
    const {
        t,
        i18n,
        tReady,
        fieldOptions,
        fieldOptionalText,
        fieldTooltip,
        fieldName,
        fieldContainerClassName,
        fieldTitle,
        fieldDefaultValue,
        fieldId,
        fieldDisabled,
        fieldDisabledPopover,
        value,
        handleOnChange,
        fieldRequired,
        fieldInputClass,
        fieldHiddenLabel,
        fieldWeight,
        ...selectProps
    } = props;

    const [inputValue, setInputValue] = useState<any>(value);
    useEffect(() => {
        setInputValue(value);
    }, [value]);
    return (
        <div id={fieldId} className={'field-container '.concat(fieldContainerClassName ?? '')}>
            <div className={'field-label-container'}>
                <label htmlFor={fieldName} className={'field-label'}>
                    <>
                        {fieldHiddenLabel && fieldDisabled && (
                            <span className="accessibility-hidden">{t(fieldHiddenLabel)}</span>
                        )}
                        {t(fieldTitle)}
                        {fieldOptionalText ? (
                            <span className="field-label--optional field-optional">
                                {''.addSpace() + t(fieldOptionalText)}
                            </span>
                        ) : null}
                    </>
                </label>
                {!fieldDisabledPopover && fieldTooltip}
            </div>

            <div className="field-container">
                <select
                    id={fieldName}
                    name={fieldName}
                    disabled={fieldDisabled}
                    className={'field-input field-input--dropdown field-value '
                        .concat(fieldDisabled ? 'field-input--disabled field-value--disabled ' : '')
                        .concat(fieldInputClass ?? '')}
                    value={inputValue}
                    onChange={(e) => {
                        if (e.target.value) {
                            document
                                .getElementById(fieldName)
                                ?.classList.remove('registration-error');
                            const errorLogo = document.getElementById(fieldName + '_error_logo');
                            if (errorLogo) {
                                errorLogo!.style.display = 'none';
                            }
                        }
                        setInputValue(e.target.value);
                        handleOnChange && handleOnChange(e);
                    }}
                    data-set-required={fieldRequired}
                    data-set-weight={fieldWeight}
                    aria-required={fieldRequired}
                    aria-disabled={fieldDisabled}
                    {...selectProps}
                >
                    {fieldDefaultValue ? (
                        <option value="" disabled>
                            {t(fieldDefaultValue)}
                        </option>
                    ) : null}
                    {fieldOptions}
                </select>
                <NotificationLogo
                    id={fieldName + '_error_logo'}
                    className="field-error-icon field-error-icon--dropdown"
                />
            </div>
        </div>
    );
};
export default withTranslation()(DropDownField);
